export enum ProjectTemplateMappingModes {
  Add,
  Edit,
  View,
  Copy,
}
